module.exports = __webpack_public_path__ + "static/media/191CS146.98fbb356.JPG";